"use client";
import styled from "../../../client-utils/styled/index.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import LinkAtom from "../../../components/atoms/Link/Link.atom.js";
import TypographyAtom from "../../../components/atoms/Typography/Typography.atom.js";
const coreComponentName = "SdbBreadcrumb";
export const Link = styled(LinkAtom, {
    name: coreComponentName,
    slot: "Link",
    shouldForwardProp: shouldForwardProp("highlight"),
})(({ highlight, theme }) => ({
    color: highlight ? theme.vars.palette.surface.on : theme.vars.palette.primary.main,
}));
export const Typography = styled(TypographyAtom, {
    name: coreComponentName,
    slot: "Typography",
    shouldForwardProp: shouldForwardProp("highlight"),
})(({ highlight, theme }) => ({
    color: highlight ? theme.vars.palette.surface.on : theme.vars.palette.primary.main,
}));
